import React from 'react'
import copyImg from "../../../assets/icons/Group 127.svg"
import { notification } from 'antd'
import GitLogo from '../../../assets/icons/image 70.svg'
import walletIcon from '../../../assets/icons/image 81n.svg'
import tokenIcon from '../../../assets/icons/image 83.svg'
import DatalakeIcon from '../../../assets/icons/image 82.svg'
import gaslessIcon from '../../../assets/icons/image 85.svg'
import smIcon from '../../../assets/icons/image 84.svg'
import idIcon from '../../../assets/icons/image 65.svg'
import infaIcon from '../../../assets/icons/image 66.svg'
import storageIcon from '../../../assets/icons/image 81.svg'
import { useInView } from 'react-intersection-observer'
import useIntersectionObserver from './useIntersectionObserver'





const Features = () => {
    const command = process.env.REACT_APP_LANDING_PAGE_COMMAND
    const github= process.env.REACT_APP_GITHUB_SDK
    const onCopy = (apiKey) => {
        navigator.clipboard.writeText(apiKey);
        notification.success({
            message: "Copied to clipboard",
            duration: 3,
        });
    };

      const [ref, isInView] = useIntersectionObserver({
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      });

  return (
    <div className='light-theme-features' id="start-with-krypCore">
        <h2 ref={ref} className={`light-theme-features-header ${isInView ?'animated animatedFadeInUp fadeInUp':'hidden'}`} >A Feature Set For</h2> 
        <h2 ref={ref} className={`light-theme-features-header1 ${isInView ?'animated animatedFadeInUp fadeInUp':'hidden'}`} >All <span className='light-theme-features-gradient'>Web3</span>  Use Cases</h2>
        <p className='light-theme-features-para mb-5'>Krypcore Web3 provides a comprehensive suite of APIs enabling developers <br className="light-theme-hiddenbreaktag" /> to build versatile decentralized applications.</p>
   
            <div  className="light-theme-features-row">
            <div className='light-theme-features-box'>
                <div className='light-theme-sdk-card'>
                  <h2 className='light-theme-feature-header2'>Krypcore <span className='light-theme-feature-header2-gradient'>SDK</span></h2>
                    <div className='light-theme-sdk-card-field'>
                        <div className="light-startK-footer">
                            <div className="light-buildK-field">
                                <div className="light-buildK-text-card">{command}<img src={copyImg} alt="Illustration-of-Web3-SDK" style={{cursor:'pointer'}} onClick={() => onCopy(command)}/></div>
                            </div>                
                        </div>
                        <img src={GitLogo} height='40px' width='40px'/>
                    </div>
                </div> 
                </div>
                <div className='light-theme-features-box'>
                    <div className='light-theme-features-box-heading'>
                        <img  src={walletIcon} alt="Wallet" height='auto' width='auto'/>
                        <h2 className='light-theme-feature-header2'>Wallet</h2>
                    </div>
                    <p className="light-theme-features-box-para">
                        Create wallets, manage accounts, sign <br className="light-theme-hiddenbreaktag" />  transactions and perform other wallet related <br className="light-theme-hiddenbreaktag" />  operations
                    </p>
                </div>
       
                <div className='light-theme-features-box'>
                    <div className='light-theme-features-box-heading'>
                        <img  src={tokenIcon} alt="Wallet" height='auto' width='auto'/>
                        <h2 className='light-theme-feature-header2'>Token</h2>
                    </div>
                    <p className="light-theme-features-box-para">
                        Create, transfer, burn tokens and query token <br className="light-theme-hiddenbreaktag" />  metadata
                    </p>
                </div>
            
           </div>
           <div  className="light-theme-features-row">
                <div className='light-theme-features-box'>
                    <div className='light-theme-features-box-heading'>
                        <img  src={DatalakeIcon} alt="Wallet" height='auto' width='auto'/>
                        <h2 className='light-theme-feature-header2'>Datalake</h2>
                    </div>
                    <p className="light-theme-features-box-para">
                    Get detailed transaction data, including transaction <br className="light-theme-hiddenbreaktag" /> history, gas usage related to dApps
                    </p>
                </div>
         
                <div className='light-theme-features-box'>
                    <div className='light-theme-features-box-heading'>
                        <img  src={gaslessIcon} alt="Wallet" height='auto' width='auto'/>
                        <h2 className='light-theme-feature-header2'>Gasless</h2>
                    </div>
                    <p className="light-theme-features-box-para">
                        Handle gas fees on behalf of your users
                    </p>
                </div>
            
                <div className='light-theme-features-box'>
                    <div className='light-theme-features-box-heading'>
                        <img  src={smIcon} alt="Wallet" height='auto' width='auto'/>
                        <h2 className='light-theme-feature-header2'>Smart Contract</h2>
                    </div>
                    <p className="light-theme-features-box-para">
                        Deployment, invoke, manage smart <br className="light-theme-hiddenbreaktag" />  contracts and query contract state
                    </p>
                </div>
        
              </div>
              <div  className="light-theme-features-row">
                <div className='light-theme-features-box'>
                    <div className='light-theme-features-box-heading'>
                        <img  src={idIcon} alt="Wallet" height='auto' width='auto'/>
                        <h2 className='light-theme-feature-header2'>Identity</h2>
                    </div>
                    <p className="light-theme-features-box-para">
                    Create, issue, verify and revoke credentials <br className="light-theme-hiddenbreaktag" />  associated with Decentralized Identifiers (DIDs)  </p>
                </div>
                <div className='light-theme-features-box'>
                    <div className='light-theme-features-box-heading'>
                        <img  src={infaIcon} alt="Wallet" height='auto' width='auto'/>
                        <h2 className='light-theme-feature-header2'>Infrastructure</h2>
                    </div>
                    <p className="light-theme-features-box-para">
                    Communicate with the blockchain network <br className="light-theme-hiddenbreaktag" /> and perform various operations such as <br className="light-theme-hiddenbreaktag" />  querying blockchain data, submitting <br className="light-theme-hiddenbreaktag" />  transactions etc  </p>
                </div>
               
        
                <div className='light-theme-features-box'>
                    <div className='light-theme-features-box-heading'>
                        <img  src={storageIcon} alt="Wallet" height='auto' width='auto'/>
                        <h2 className='light-theme-feature-header2'>Storage</h2>
                    </div>
                    <p className="light-theme-features-box-para">
                      Store, retrieve, and managet decentralized <br className="light-theme-hiddenbreaktag" />  data, including files, media, and metadata <br className="light-theme-hiddenbreaktag" />  associated with Dapps 
                    </p>
                </div>
            </div> 
        
    </div>
  )
}

export default Features